import React from 'react';
import { Building2, Users, CreditCard, Settings, FileText, ToggleLeft, Shield } from 'lucide-react';

const AdminSidebar = ({ activeTab, setActiveTab }) => {
  const menuItems = [
    {
      id: 'organizations',
      label: 'Organizations',
      icon: Building2,
      description: 'Manage all organizations'
    },
    {
      id: 'users',
      label: 'Users',
      icon: Users,
      description: 'User management'
    },
    {
      id: 'billing',
      label: 'Billing & Usage',
      icon: CreditCard,
      description: 'Subscriptions and usage'
    },
    {
      id: 'features',
      label: 'Feature Flags',
      icon: ToggleLeft,
      description: 'Feature toggles'
    },
    {
      id: 'audit',
      label: 'Audit Logs',
      icon: FileText,
      description: 'System activity logs'
    },
    {
      id: 'settings',
      label: 'System Settings',
      icon: Settings,
      description: 'Platform configuration'
    }
  ];

  return (
    <div className="w-64 bg-white shadow-lg h-full">
      <div className="p-6 border-b border-gray-200">
        <div className="flex items-center">
          <div className="bg-blue-600 rounded-lg p-2">
            <Shield className="w-6 h-6 text-white" />
          </div>
          <div className="ml-3">
            <h2 className="text-lg font-semibold text-gray-900">Super Admin</h2>
            <p className="text-sm text-gray-500">System Control</p>
          </div>
        </div>
      </div>
      <nav className="mt-6 px-3">
        {menuItems?.map((item) => {
          const IconComponent = item?.icon;
          const isActive = activeTab === item?.id;
          
          return (
            <button
              key={item?.id}
              onClick={() => setActiveTab(item?.id)}
              className={`w-full flex items-center px-3 py-3 text-left rounded-lg mb-2 transition-colors ${
                isActive
                  ? 'bg-blue-50 text-blue-700 border-r-2 border-blue-700' :'text-gray-700 hover:bg-gray-50'
              }`}
            >
              <IconComponent className={`w-5 h-5 mr-3 ${isActive ? 'text-blue-700' : 'text-gray-400'}`} />
              <div className="flex-1">
                <div className={`font-medium ${isActive ? 'text-blue-700' : 'text-gray-900'}`}>
                  {item?.label}
                </div>
                <div className="text-sm text-gray-500">
                  {item?.description}
                </div>
              </div>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default AdminSidebar;